import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Confirm, Alert } from "../../../js/ComponentManager";
import { Link } from 'react-router-dom';
import { RegisterCard } from '../../Common/RegisterCard';

/* 개발담당:양유빈
 * 화면기능:마이페이지 메인
 * 세부설명:
*/

export class MyPage extends Component {
    static displayName = MyPage.name;

    constructor(props) {
        super(props);
        this.state = {
            WholeCount: 0,
            Use_Yn: "N",
            Refund_Yn: "N",
            Bill_Yn: "N",
            Clod_Point: "",
            Content: "",
            Title: "",
            Jm_Count: 0,
            DeviceToken: [],
            IsSecondary: Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.IsSecondary)
        };
        this.handleLogOut_Click = this.handleLogOut_Click.bind(this);
/*        this.GetRefund = this.GetRefund.bind(this);
        this.GetPoint = this.GetPoint.bind(this);*/
        this.handle_CancleRefund = this.handle_CancleRefund.bind(this);
        this.handle_RenderComponent = this.handle_RenderComponent.bind(this);
        this.handleAlarm_Change = this.handleAlarm_Change.bind(this);
        this.RegisterCardRef = React.createRef();
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
        
    }
    //초기화
    componentDidMount() {
        this.CallMyWholeListCount();
        if (this.Uid_Type === 'TS') {
            this.GetbillingKey();
        }       
    }
    async handleLogOut_Click() {
        try {
            let Data = await Big3Common.Get("api/Common/Common/Logout");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.Util.RemoveLoginStorage();
                Big3Common.Util.OpenWindowLink("/Account/LoginMgr/Index");
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("handleLogOut_Click: ", e)
        }
        return false;
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //포인트 조회
    async GetPoint() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetPoint", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Clod_Point = DataList[0]["total_point"]
                this.setState({
                    Clod_Point: Clod_Point
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetPoint: ", e)
        }
        return false;
    }*/
    //내 거래매장 건수 가져오기
    async CallMyWholeListCount() {
        try {

            let Data = await Big3Common.Get('api/MyPage/MyInfoMgr/GetMyWholeListCount');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrderList = DataList.OrderList;
                const DeviceToken = DataList.DeviceToken;
                let Jm_Count = 0;
                if (OrderList.length > 0) {
                    Jm_Count = OrderList[0]["jm_count"] + OrderList[0]["order_count"];
                }
                this.setState({
                    WholeCount: DataList.Count,
                    Use_Yn: DataList.Use_Yn,
                    Jm_Count: Jm_Count,
                    DeviceToken: DeviceToken
                });
            }
        }
        catch (e) {
            console.log("CallMyWholeListData", e);
        }

    }
    //링크
    async handle_RenderComponent(event, ComponentName) {
        if (ComponentName === 'ChargePoint') {
            if (this.state.Bill_Yn === "N") {
                this.setState({ Title: "카드 등록 후 충전이 가능합니다." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else {
                this.props.RenderComponent(ComponentName);
            }
        }
        else {
            this.props.RenderComponent(ComponentName);
        }
        event.preventDefault();
    }
    //알람수신 여부 설정
    handleAlarm_Change = async (event) => {
        try {

            const Use_Yn = event.target.checked === true ? "Y" : "N";
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/SetDeviceMgtUseYn', {
                Use_Yn: Use_Yn
            }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Use_Yn: Use_Yn });
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Title: "알림설정안내", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("CallMyWholeListData", e);
        }

        return false;
    }
    handle_ChargePoint = async (event) => {
        this.ChargePointRef.current.requestPayment();
        Big3Common.ModalAlert(bootstrap, "ChargePoint");
        event.preventDefault();
    }
    handle_CancleRefund = async (event) => {
        try {
            let Data = await Big3Common.Post('api/Common/Common/CancleRefund', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: "환불취소안내", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                this.GetRefund();
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Title: "환불취소안내", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handle_CancleRefund", e);
        }
        return false;
    }
    handle_DeleteCard = async (event) => {
        try {
            let Data = await Big3Common.Post('api/Common/Common/DeleteCard', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: "카드등록취소안내", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                this.GetRefund();
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Title: "카드등록취소", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handle_CancleRefund", e);
        }
        return false;
    }
    render() {
        return (
            <div className="container_box m_margin">
                <div className="mypage_info">
                    <div className="shop_name">{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.OrgName)}</div>
                    <div className="login_name">{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.UserName)}님 반갑습니다!!</div>
                    <div className="shop_retail">내 거래매장 : {this.state.WholeCount}개 매장</div>
                    {
                        this.Uid_Type === 'TS' ? 
                            <div className="point_box flex_sb">
                                <div onClick={(e) => { this.handle_RenderComponent(e, 'PaymentList') }}>
                                    <div className="point_tit flex_fs">결제내역<span className="go"></span></div>
                                    {/*<div className="my_point">{Big3Common.Util.Money(this.state.Clod_Point)}P</div>*/}
                                </div>
                                <div className="button_box flex_fe">
                                    {
                                        this.state.Refund_Yn === 'N' ?
                                            <>
                                                {/*<button className="point_c" onClick={(e) => { this.handle_RenderComponent(e, 'ChargePoint') }}>포인트충전</button>*/}
                                                <button className="point_c" onClick={(e) => { this.handle_RenderComponent(e, 'RefundPolicy') }}>카드등록</button>
                                                <button className="point_w" onClick={(e) => { this.handle_DeleteCard(e) }}>카드등록취소</button>
                                            </>
                                            :
                                            <>
                                                {/*<button className="point_w" onClick={(e) => { this.handle_CancleRefund(e); }}>환불취소</button>*/}
                                                <button className="point_d">카드등록</button>
                                            </>
                                    }
                                </div>
                            </div>
                            :
                            <></>
                    }
                    <div className="mypage_icon_menu">
                        <div className="icon_box">
                            <Link to="/MyPage/ProcessMgr/Index">
                                <div className="icon6"></div>
                                <div className="txt">처리내역</div>
                            </Link>
                        </div>
                        <div className="icon_box">
                            <Link to="/MyPage/OrderMgr/Index">
                                <div className="icon1">
                                    {this.state.Jm_Count === 0 ? "" : <div className="m_new"></div>}
                                </div>
                                <div className="txt">주문내역</div>
                            </Link>
                        </div>
                        <div className="icon_box">
                            <Link to="/MyPage/BookMark/Index">
                                <div className="icon2"></div>
                                <div className="txt">찜리스트</div>
                            </Link>
                        </div>
                        <div className="icon_box" onClick={(e) => { this.handle_RenderComponent(e, 'AccountList') }}>
                            <div className="icon3"></div>
                            <div className="txt">거래처</div>
                        </div>
                        <div className="icon_box" onClick={(e) => { this.handle_RenderComponent(e, 'MyInfoCheck') }}>
                            <div className="icon4"></div>
                            <div className="txt">내 정보</div>
                        </div>
                    </div>
                </div>
                {
                    this.state.IsSecondary === "Y" ? ""
                        :
                        <div className="mypage_info">
                            <div className="my_page_menu_title">매장관리</div>
                            <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'StoreInfo') }}>매장 정보수정</div>
                            <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'EmpList') }}>직원 관리</div>
                            <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'TeamMatching') }}>삼촌 관리</div>
                        </div>
                }
                <div className="mypage_info">
                    <div className="my_page_menu_title">알림설정</div>
                    <div className="my_page_menu2">
                        <div className="my_page_menu">알림수신</div>
                        <div className="wrapper">
                            <input type="checkbox" id="switch" checked={this.state.Use_Yn === "Y" ? true : false} onChange={(e) => { this.handleAlarm_Change(e) }} />
                            <label htmlFor="switch" className="switch_label">
                                <span className="onf_btn"></span>
                            </label>
                        </div>
                    </div>
                    <div className="my_page_menu2">
                        <div className="my_page_menu">Device ID</div>
                        <div className="d_id">
                            {this.state.DeviceToken.length === 0 ? "" : `${this.state.DeviceToken[0].device_id.substring(0, 10)}... (${this.state.DeviceToken[0].reg_dt})`}
                        </div>
                    </div>

                </div>
                <div className="mypage_info">
                    <div className="my_page_menu_title">클로디 정보</div>
                    <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'ServiceCenter') }}>고객센터</div>
                    <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'Privacypolicy') }}>이용약관</div>
                    <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'Termsofservice') }}>개인정보 취급방법</div>
                    <div className="my_page_menu" onClick={(e) => { this.handle_RenderComponent(e, 'RefundPolicy') }}>결제 이용약관</div>
                </div>
                <div className="mypage_info bn">
                    <div className="my_page_menu_title pointer" onClick={() => {
                        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
                    }} >로그아웃</div>
                </div>
                <div className="clod_info_box">
                    <p className="clod_name">주식회사 큰삼촌컴퍼니</p>
                    <p className="clod_info">대표자명 : 이항영</p>
                    <p className="clod_info">사업자 등록번호 : 512-88-02004</p>
                    <p className="clod_info">통신판매업신고번호 : 2023-제주아라-0155</p>
                    <p className="clod_info">사업장 주소 : 제주특별자치도 제주시 동문로 9길 13-1 2층</p>
                    <p className="clod_info">유선번호 : 070-8837-3737</p>
                </div>
                <Confirm
                    id="ConfirmBox"
                    title="로그아웃 하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleLogOut_Click()
                    }}
                />
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                />
                <RegisterCard id="RegisterCard"
                    ref={this.RegisterCardRef}
                />
            </div>
        );
    }
}
